import React from 'react';
import { Grid } from "@material-ui/core";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { useDevice } from 'components/DeviceContext.js';
import programacao from '../../data/programacao.json';

const CardProgramacao = () => {
    const { isMobile } = useDevice();
    const hasProgramacaoInfo = programacao && programacao.length > 0;

    return (
        <>
            <Grid container style={{ marginLeft: isMobile ? '0' : '2em', boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.5)', borderRadius: '1em', height: hasProgramacaoInfo ? '100%' : '200px' }}>
                <Grid item style={{ width: '100%' }}>
                    <div style={{ backgroundColor: 'var(--azul-claro)', color: 'var(--branco)', width: '100%', borderTopLeftRadius: '1em', borderTopRightRadius: '1em' }}>
                        <h1 style={{ margin: 0, padding: '0.6em', fontSize: '22px' }}>
                            <AccessTimeIcon style={{ marginRight: '0.6em' }} />
                            Nossa Programação
                        </h1>
                    </div>
                    {hasProgramacaoInfo ? (
                        programacao.map((item, index) => (
                            <p style={{ margin: '1em', color: 'grey', }} key={index}>{item}</p>

                        ))
                    ) : (
                         <>
        <p style={{ margin: '1em', color: 'grey' }}>
        </p>

        <ul style={{
            margin: '0 2em 1.5em 2em',
            color: 'grey',
            lineHeight: '1.6',
            listStyleType: 'disc'
        }}>
            <li>08h - Credenciamento</li>
        </ul>
    </>
                    )}
                </Grid>
            </Grid>
        </>
    );
}

export default CardProgramacao;
